import { render, staticRenderFns } from "./m-section-usp.vue?vue&type=template&id=e58686fa&scoped=true&"
import script from "./m-section-usp.vue?vue&type=script&lang=js&"
export * from "./m-section-usp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58686fa",
  null
  
)

export default component.exports